import { Component, AfterViewInit, OnDestroy } from 'angular-ts-decorators';
import { faArrowAltUp } from '@fortawesome/pro-solid-svg-icons';

/**
 * Renders a scroll to top component
 * # Example
 * <pre>
 *  <sw-scroll-top></sw-scroll-top>
 * </pre>
 * index.html page of the app we want to augment
 */
@Component({
  selector: 'swScrollTop',
  template: require('./sw-scroll-top.html').default,
})
export class SwScrollTopComponent implements AfterViewInit, OnDestroy {
  faArrowAltUp = faArrowAltUp;
  isScrolling = false;
  constructor(
    private $document: ng.IDocumentService,
    private $window: ng.IWindowService,
    private $scope,
  ) {
    'ngInject';
  }

  private scroll() {
    this.$scope.$apply(() => (this.isScrolling = this.$window.scrollY > 0));
  }

  scrollTop() {
    this.$window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngAfterViewInit() {
    this.$document.on('scroll', () => this.scroll());
  }

  ngOnDestroy() {
    this.$document.off('scroll', () => this.scroll());
  }
}
